import type { PassThrough } from '@primevue/core';
import type { PassThroughOptionType } from '../utils';
import type { Ref } from 'vue';

export type DialogType = 'base' | 'radio' | 'multipleSelect';

// Constants for DialogType values
export const DIALOG_TYPES = {
  BASE: 'base' as const,
  RADIO: 'radio' as const,
  MULTIPLE_SELECT: 'multipleSelect' as const,
} satisfies Record<string, DialogType>;

export type SeverityType =
  | 'info'
  | 'success'
  | 'warning'
  | 'error'
  | 'base_success'
  | 'base_error';

// Constants for SeverityType values
export const SEVERITY_TYPES = {
  INFO: 'info' as const,
  SUCCESS: 'success' as const,
  WARNING: 'warning' as const,
  ERROR: 'error' as const,
  BASE_SUCCESS: 'base_success' as const,
  BASE_ERROR: 'base_error' as const,
} satisfies Record<string, SeverityType>;

export type DialogOption = {
  value: string;
  label: string;
};

export type MeridiaDialogPassThroughOptions = {
  header?: PassThroughOptionType;
  headerWrapper?: PassThroughOptionType;
  title?: PassThroughOptionType;
  subtitle?: PassThroughOptionType;
  icon?: PassThroughOptionType;
  content?: PassThroughOptionType;
  contentWrapper?: PassThroughOptionType;
  radio?: PassThroughOptionType;
  checkbox?: PassThroughOptionType;
  footer?: PassThroughOptionType;
  footerWrapper?: PassThroughOptionType;
  secondaryButton?: PassThroughOptionType;
  primaryButton?: PassThroughOptionType;
};

export type MeridiaDialogProps = {
  title: string;
  subtitle?: string;
  type: DialogType;
  options?: DialogOption[];
  severityType: SeverityType;
  primaryButtonFunction: (
    close: () => void,
    loading: Ref<boolean>
  ) => void | Promise<void>;
  secondaryButtonFunction?: (
    close: () => void,
    loading: Ref<boolean>
  ) => void | Promise<void>;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
  primaryButtonIcon?: string;
  secondaryButtonIcon?: string;
  primaryButtonTooltip?: string;
  secondaryButtonTooltip?: string;
  pt?: PassThrough<MeridiaDialogPassThroughOptions>;
  appendTo?: string | HTMLElement;
};
